import 'bootstrap/dist/css/bootstrap.min.css';
import { Settings } from 'luxon';
import { createRoot } from 'react-dom/client';
import App from './app';
import { ConditionalStrictMode } from './hooks/ConditionalStrictMode';
import './i18n/config';

// Set the default timezone
Settings.defaultZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Register service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .catch(error =>
      console.error('Service Worker registration failed:', error),
    );
}

createRoot(document.getElementById('root')!).render(
  <ConditionalStrictMode>
    <App />
  </ConditionalStrictMode>,
);
